/* Smakguiden – Whiskybud. Rekommenderar 3 flaskor utifrån fyra frågor. */
(function () {
  if (window.__smakguide) return;
  window.__smakguide = true;

  var Q = [
    { k: 'vem', q: 'Vem ska whiskyn till?', o: [
      ['present', 'Det är en present', 'Vi prioriterar presentaskar och paket med glas'],
      ['mig', 'Till mig själv', 'Vi fokuserar på det som finns i flaskan']] },
    { k: 'niva', q: 'Hur whiskyvan är den som ska dricka?', h: 'Gissa om du inte vet säkert.', o: [
      ['1', 'Ny på whisky', 'Dricker sällan eller aldrig whisky'],
      ['2', 'Dricker ibland', 'Har några favoriter'],
      ['3', 'Riktig kännare', 'Har provat mycket och vill bli överraskad']] },
    { k: 'smak', q: 'Vilken smak passar bäst?', o: [
      ['mild', 'Mjuk och len', 'Vanilj, honung, lätt frukt'],
      ['fruktig', 'Fruktig och söt', 'Sherry, torkad frukt, karamell'],
      ['rokig', 'Rökig', 'Torvrök, hav, lägereld'],
      ['vet', 'Vet inte', 'Vi väljer säkra kort']] },
    { k: 'budget', q: 'Ungefär vilken budget?', o: [
      ['lag', 'Under 800 kr', ''], ['mellan', '800–1 100 kr', ''],
      ['hog', 'Över 1 100 kr', ''], ['alla', 'Spelar ingen roll', '']] }
  ];
  var RANGE = { lag: [0, 799], mellan: [800, 1100], hog: [1101, 1e9], alla: [0, 1e9] };
  var NIVA = { 'niva-nyborjare': 1, 'niva-van': 2, 'niva-kannare': 3 };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function kr(n) { return Math.round(n).toLocaleString('sv-SE') + ' kr'; }

  function loadProducts() {
    var el = document.getElementById('smakguide-data');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent).filter(function (p) { return p.a; }).map(function (p) {
        var tags = (p.g || []).map(function (t) { return String(t).toLowerCase(); });
        var smak = 'mild';
        ['mild', 'fruktig', 'rokig', 'blandat'].forEach(function (s) { if (tags.indexOf('smak-' + s) > -1) smak = s; });
        var niva = tags.map(function (t) { return NIVA[t]; }).filter(Boolean);
        return { t: p.t, u: p.u, p: +p.p, i: p.i, w: p.w, s: smak, n: niva.length ? niva : [2], g: tags.indexOf('present') > -1 };
      });
    } catch (e) { return []; }
  }

  function score(p, a) {
    var sc = 0;
    if (a.smak === 'vet') sc += (p.s === 'mild' || p.s === 'blandat') ? 3 : p.s === 'fruktig' ? 2 : 0;
    else sc += p.s === a.smak ? 5 : p.s === 'blandat' ? 2 : 0;
    var lv = +a.niva;
    sc += p.n.indexOf(lv) > -1 ? 3 : p.n.some(function (x) { return Math.abs(x - lv) === 1; }) ? 1 : -1;
    if (a.vem === 'present' && p.g) sc += 3;
    var r = RANGE[a.budget];
    if (p.p >= r[0] && p.p <= r[1]) sc += 4;
    else sc -= Math.min(6, Math.abs(p.p - (p.p < r[0] ? r[0] : r[1])) / 150);
    return sc;
  }

  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }

  function bottle() {
    return '<svg viewBox="0 0 44 88" aria-hidden="true"><path d="M17 2h10v14c0 3 9 7 9 16v50a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V32c0-9 9-13 9-16z" fill="currentColor" opacity=".35"/></svg>';
  }

  function init(root, products) {
    var step = 0, ans = {};
    var prog = root.querySelector('[data-sg-progress]');
    var body = root.querySelector('[data-sg-body]');

    function render() {
      prog.innerHTML = Q.map(function (_, i) { return '<i class="' + (i <= step ? 'on' : '') + '"></i>'; }).join('');
      if (step < Q.length) {
        var q = Q[step];
        body.innerHTML = '<div class="sg-q">' + q.q + '</div>' + (q.h ? '<div class="sg-hint">' + q.h + '</div>' : '') +
          '<div class="sg-opts">' + q.o.map(function (o, i) {
            return '<button type="button" class="sg-opt" data-v="' + o[0] + '"><span class="sg-ic">' + String.fromCharCode(65 + i) +
              '</span><span class="sg-ol">' + o[1] + (o[2] ? '<small>' + o[2] + '</small>' : '') + '</span></button>';
          }).join('') + '</div>' +
          '<div class="sg-foot">' + (step > 0 ? '<button type="button" class="sg-link" data-sg-back>Tillbaka</button>' : '<span></span>') +
          '<span>Fråga ' + (step + 1) + ' av ' + Q.length + '</span></div>';
        body.querySelectorAll('.sg-opt').forEach(function (b) {
          b.addEventListener('click', function () {
            if (step === 0) track('smakguide_started');
            ans[q.k] = b.getAttribute('data-v'); step++; render();
            var first = body.querySelector('.sg-opt, .sg-buy'); if (first) first.focus({ preventScroll: true });
          });
        });
        var bk = body.querySelector('[data-sg-back]');
        if (bk) bk.addEventListener('click', function () { step--; render(); });
      } else {
        var ranked = products.map(function (p) { return [score(p, ans), p]; })
          .sort(function (a, b) { return b[0] - a[0]; }).slice(0, 3);
        track('smakguide_completed', { svar: ans });
        var lab = function (k) { var q = Q.filter(function (x) { return x.k === k; })[0]; return q.o.filter(function (o) { return o[0] === ans[k]; })[0][1]; };
        body.innerHTML = '<div class="sg-q">Våra tre förslag</div>' +
          '<div class="sg-summary">' + [lab('vem'), lab('niva'), lab('smak'), lab('budget')].join(' · ') + '</div>' +
          (ranked.length ? '<div class="sg-recs">' + ranked.map(function (r, i) {
            var p = r[1];
            var href = p.u + (p.u.indexOf('?') > -1 ? '&' : '?') + 'utm_source=smakguide&utm_medium=onsite&utm_campaign=smakguide';
            return '<div class="sg-rec' + (i === 0 ? ' sg-top' : '') + '">' +
              (p.i ? '<img src="' + esc(p.i) + '" alt="" width="64" height="96" loading="lazy">' : bottle()) +
              '<div>' + (i === 0 ? '<div class="sg-badge">Bäst match</div>' : '') +
              '<div class="sg-t">' + esc(p.t) + '</div>' + (p.w ? '<div class="sg-why">' + esc(p.w) + '</div>' : '') +
              '<div class="sg-row"><span class="sg-price">' + kr(p.p) + '</span><a class="sg-buy" href="' + esc(href) + '">Visa flaskan</a></div></div></div>';
          }).join('') + '</div>' : '<p class="sg-hint">Vi hittade tyvärr inga flaskor i lager just nu.</p>') +
          '<div class="sg-foot"><button type="button" class="sg-link" data-sg-again>Börja om</button><span>Drick med måtta</span></div>';
        body.querySelector('[data-sg-again]').addEventListener('click', function () { step = 0; ans = {}; render(); });
        body.querySelectorAll('.sg-buy').forEach(function (a) {
          a.addEventListener('click', function () { track('smakguide_click', { produkt: a.closest('.sg-rec').querySelector('.sg-t').textContent }); });
        });
      }
    }
    render();
  }

  function initFloat(wrap) {
    var panel = wrap.querySelector('.sg-panel');
    var btn = wrap.querySelector('[data-sg-open]');
    var nudge = wrap.querySelector('[data-sg-nudge]');
    function open() { panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); wrap.classList.add('is-open'); if (nudge) nudge.hidden = true;
      var f = panel.querySelector('.sg-opt'); if (f) f.focus({ preventScroll: true }); track('smakguide_opened'); }
    function close() { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); wrap.classList.remove('is-open'); btn.focus({ preventScroll: true }); }
    btn.addEventListener('click', function () { panel.hidden ? open() : close(); });
    wrap.querySelector('[data-sg-close]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

    // En liten påminnelse efter 20 sekunder, en gång per besök, inte i kassan eller på produktsidor
    if (nudge && !/\/(checkouts?|cart|products)\b/.test(location.pathname)) {
      var seen = false; try { seen = sessionStorage.getItem('sg-nudge') === '1'; } catch (e) {}
      if (!seen) setTimeout(function () {
        if (panel.hidden) { nudge.hidden = false; try { sessionStorage.setItem('sg-nudge', '1'); } catch (e) {} }
      }, 20000);
      wrap.querySelector('[data-sg-nudge-close]').addEventListener('click', function () { nudge.hidden = true; });
    }
  }

  function boot() {
    var products = loadProducts();
    document.querySelectorAll('[data-smakguide]').forEach(function (root) { init(root, products); });
    document.querySelectorAll('[data-smakguide-float]').forEach(initFloat);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
